import { ReactNode } from "react";
import { cn } from "@/utils/cn";

export type CalloutTone = "gray" | "blue" | "amber" | "red" | "green";

const TONES: Record<CalloutTone, string> = {
  gray: "bg-gray-50 text-gray-600",
  blue: "bg-blue-50 text-blue-700",
  amber: "bg-amber-50 text-amber-800",
  red: "bg-red-50 text-red-700",
  green: "bg-green-50 text-green-700",
};

/** Inline explanatory or warning text inside a panel or modal. Flat, no border. */
export function Callout({ children, tone = "gray", className }: { children: ReactNode; tone?: CalloutTone; className?: string }) {
  return <div role={tone === "red" ? "alert" : undefined} className={cn("rounded-lg px-3 py-2 text-xs", TONES[tone], className)}>{children}</div>;
}
